import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteVideo } from "./deleteVideo.request";

const useDeleteFeedInsert = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchFeedInserts = useRefetchQuery(["feed-inserts"]);
  return useMutation({
    mutationFn: requestDeleteVideo,
    ...options,
    onSuccess: (...args) => {
      refetchFeedInserts();
      options?.onSuccess?.(...args);
    }
  });
};

export default useDeleteFeedInsert;
